<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						上传文件
					</div>
					<div style="padding: 20px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px"
							class="demo-ruleForm" label-position="right">
							<el-form-item label="选择文件" prop="name">
								<div style="display: flex;flex-direction: column;">
									<el-upload class="upload-demo" ref="upload"
										action="https://jsonplaceholder.typicode.com/posts/" :multiple="false"
										:show-file-list="false" :before-upload="beforeUpload">
										<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
									</el-upload>
									<span style="font-size: 14px;color: #fff;">{{ruleForm.name}}</span>
									<div style="display: flex;align-items: center;margin-top: -20px;" v-if="showProgress">
										<el-progress :percentage="upload_percent" :show-text="false"  style="color: #fff !important;flex:1"></el-progress>
										<span style="font-size: 13px;color:#fff;margin-left: 5px;flex-shrink: 0;">{{upload_percent}}%</span>
									</div>
									
								</div>
							</el-form-item>
							<el-form-item label="备注">
								<el-input type="text" placeholder="请输入备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">修改</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						收费标准
					</div>
					<div style="padding: 20px;">
						<div style="margin-bottom: 10px;">收费分为两部分，1：文件存储费用。2：文件下载费用。</div>
						<div style="margin-bottom: 10px;">文件存储费用以及规则：
							1mb/0.01元(每月)，就是说：这个文件10mb，那么，每个月会从余额中扣除0.1元，余额不足则删除文件，不足1mb的文件，按照1m算</div>
						<div>文件下载费用以及规则：
							10mb/0.01元，就是说：这个文件10mb，那么，用户每下载一次这个文件，就会从余额中扣除0.01元，不足10mb的文件，按照10m算，余额不足则无法下载。</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				file:{},
				ruleForm: {
					one: '',
					name: '',
					size: '',
					type: 'update',
				},
				showProgress:false,
				upload_percent: 0,
				show_loading:false,
				rules: {
					name: [{
						required: true,
						message: '请选择要上传的文件',
						trigger: 'change'
					}],
					one: [{
						required: true,
						message: '请输入文件备注',
						trigger: 'blur'
					}],
				},
			}
		},
		props:{
			id:[String,Number]
		},
		created() {
			this.resetForm()
			this.getData(this.id)
		},
		methods: {
			getData(id){
				this.$H.post('verify_center/v1_0_1.Files/Info',{
					file_id:id
				}).then(res => {
					let data = res.data.info
					this.file = {
						name:res.data.info.filename
					}
					this.ruleForm.name = data.filename
					this.ruleForm.size = data.size
					this.ruleForm.one = data.one
				});
				
			},
			beforeUpload(file) {
				console.log(file);
				this.ruleForm.name = file.name
				this.ruleForm.size = file.size
				this.file = file
				this.$H.post('verify_center/v1_0_1.Files/GetUploadInfo', {
					one: this.ruleForm.one,
					name: this.ruleForm.name,
					size: this.ruleForm.size,
					type: this.ruleForm.type,
					file_id: this.id,
				}).then(res => {
					console.log(res.code)
					if(res.code!==0) return;
					let data = {
						...res.data.info,
						file:this.file
					}
					console.log(res.data.info)
					try {
						// 构造表单数据
						const formData = new FormData();
						formData.append('key', res.data.info.key);
						formData.append('policy', res.data.info.policy);
						formData.append('OSSAccessKeyId', res.data.info.OSSAccessKeyId);
						formData.append('signature', res.data.info.signature);
						formData.append('callback', res.data.info.callback);
						formData.append('file', file);
						formData.append('success_action_status', 200)
						this.upload_percent = 0
						// 使用 POST 请求上传文件
						axios.post(res.data.info.host,formData, {
							headers: {
								'Content-Type': 'multipart/form-data'
							},
							onUploadProgress:(data)=>{
								console.log(res.data.info.host + '/' + res.data.info.key)
								this.showProgress = true
								let {progress} = data
								this.upload_percent = parseFloat((progress*100).toFixed(2))
								console.log(this.upload_percent)
								if(progress==1){
									this.show_loading = false
									this.$message.success('上传成功')
								}else{
									this.show_loading = true
								}
							}
						}).then(res=>{
							
							console.log(res)
						}).catch(err=>{
							this.$message.error('上传失败')
							this.showProgress = false
							console.log(err)
						})
					} catch (error) {
						console.error('文件上传失败：', error);
					}
					
				})
				return false
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('verify_center/v1_0_1.Files/UpdateFileOne', {
							one: this.ruleForm.one,
							file_id: this.id,
						}).then(res => {
							if(res.data){
								this.$message.success('修改成功')
								this.$emit('back')
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.el-progress__text{
		color: #fff !important;
	}
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;
		border-bottom: 1px solid #000;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>